/* build: 1776461457811 */
/* ═══════════════════════════════════════════════════════════════
   Limsa Addons v3 — dark mode, sidebar, scroll, cookie, lazy
   Vanilla JS. No deps. defer.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var DARK_KEY = 'limsa-theme';
  var html = document.documentElement;

  /* ─────────────────────────────────────────────────────────
     Dark Mode — applies before paint via inline script in <head>
     (see theme.liquid). This just handles the toggle button.
     ───────────────────────────────────────────────────────── */
  function initDarkMode() {
    var btn = document.getElementById('LimsaDarkToggle');
    if (!btn) return;

    function apply(dark) {
      if (dark) {
        html.setAttribute('data-limsa-theme', 'dark');
        btn.setAttribute('aria-label', 'Switch to light mode');
      } else {
        html.removeAttribute('data-limsa-theme');
        btn.setAttribute('aria-label', 'Switch to dark mode');
      }
    }

    btn.addEventListener('click', function () {
      var isDark = html.getAttribute('data-limsa-theme') === 'dark';
      var next = !isDark;
      /* Save explicit choice; 'auto' means "follow OS" — we save dark/light only on manual toggle */
      localStorage.setItem(DARK_KEY, next ? 'dark' : 'light');
      apply(next);
    });

    /* Long-press (500ms) resets to OS auto mode */
    var pressTimer;
    btn.addEventListener('pointerdown', function(){ pressTimer = setTimeout(function(){ localStorage.setItem(DARK_KEY,'auto'); location.reload(); }, 500); });
    btn.addEventListener('pointerup',   function(){ clearTimeout(pressTimer); });
    btn.addEventListener('pointerleave',function(){ clearTimeout(pressTimer); });
  }

  /* ─────────────────────────────────────────────────────────
     Bidirectional scroll button
     ───────────────────────────────────────────────────────── */
  function initScrollBtn() {
    var btn = document.getElementById('LimsaScrollBtn');
    if (!btn) return;
    var savedY = 0;

    function update() {
      var y = window.pageYOffset;
      if (y > 300) {
        btn.dataset.direction = 'up';
        btn.setAttribute('aria-label', 'Back to top');
        btn.classList.add('is-visible');
      } else if (savedY > 300) {
        btn.dataset.direction = 'down';
        btn.setAttribute('aria-label', 'Return to previous position');
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
      }
    }

    btn.addEventListener('click', function () {
      if (btn.dataset.direction === 'up') {
        savedY = window.pageYOffset;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        var t = savedY; savedY = 0;
        window.scrollTo({ top: t, behavior: 'smooth' });
      }
    });

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () { update(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  /* ─────────────────────────────────────────────────────────
     Currency / Language panel
     ───────────────────────────────────────────────────────── */
  function initCurrencyPanel() {
    var trigger = document.getElementById('LimsaCurrencyTrigger');
    var panel   = document.getElementById('LimsaCurrencyPanel');
    var closeBtn= document.getElementById('LimsaCurrencyClose');
    var form    = document.getElementById('LimsaLocaleForm');
    if (!trigger || !panel || !form) return;

    function open() {
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      setTimeout(function () {
        document.addEventListener('click', outside, true);
        document.addEventListener('keydown', onKey);
      }, 10);
    }
    function close() {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', outside, true);
      document.removeEventListener('keydown', onKey);
    }
    function outside(e) {
      var wrap = document.getElementById('LimsaCurrencyWrap');
      if (wrap && !wrap.contains(e.target)) close();
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(); trigger.focus(); }
    }

    trigger.addEventListener('click', function () {
      panel.classList.contains('is-open') ? close() : open();
    });
    if (closeBtn) closeBtn.addEventListener('click', close);

    panel.querySelectorAll('[data-value]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var inp = document.getElementById('LimsaCountryInput');
        if (inp) inp.value = link.dataset.value;
        close();
        setTimeout(function () { form.submit(); }, 120);
      });
    });
    panel.querySelectorAll('[data-locale]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var inp = document.getElementById('LimsaLocaleInput');
        if (inp) inp.value = link.dataset.locale;
        close();
        setTimeout(function () { form.submit(); }, 120);
      });
    });
  }

  /* ─────────────────────────────────────────────────────────
     Cookie banner
     ───────────────────────────────────────────────────────── */
  function initCookie() {
    if (localStorage.getItem('limsa-cookie-consent')) return;
    var banner = document.querySelector('.limsa-cookie-banner');
    if (!banner) return;
    setTimeout(function () { banner.classList.add('is-visible'); }, 2500);
    banner.querySelectorAll('[data-cookie-accept]').forEach(function (b) {
      b.addEventListener('click', function () {
        localStorage.setItem('limsa-cookie-consent', 'accepted');
        banner.classList.remove('is-visible');
      });
    });
    banner.querySelectorAll('[data-cookie-decline]').forEach(function (b) {
      b.addEventListener('click', function () {
        localStorage.setItem('limsa-cookie-consent', 'declined');
        banner.classList.remove('is-visible');
      });
    });
  }

  /* ─────────────────────────────────────────────────────────
     Lazy images
     ───────────────────────────────────────────────────────── */
  function initLazy() {
    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (img.complete) img.classList.add('is-loaded');
      else img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
    });
  }

  /* ─────────────────────────────────────────────────────────
     Reveal on scroll
     ───────────────────────────────────────────────────────── */
  function initReveal() {
    var items = document.querySelectorAll('[data-reveal]');
    if (!items.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ─────────────────────────────────────────────────────────
     Boot
     ───────────────────────────────────────────────────────── */
  function boot() {
    initDarkMode();
    initScrollBtn();
    initCurrencyPanel();
    initCookie();
    initLazy();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* ─────────────────────────────────────────────────────────
   * "You may also like" slider — hız yavaşlat
   * Tema Swiper'ı auto_play saniye bazında alıyor. data-slider-options
   * içindeki auto_play değerini ~4s'e çek (kartlar okunur süreyle kalır).
   * Swiper instance'ı mount sonrası params.autoplay.delay'i de güncelle.
   * ───────────────────────────────────────────────────────── */
  function tuneRelatedSliders() {
    try {
      // Mobilde >1s olmalı; desktop 1s OK → tek değer 1800ms (>1s garantisi)
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
      var AUTO_DELAY = isMobile ? 2000 : 1500;  // mobilde 2s, desktop 1.5s
      var TRANS_SPEED = 700;

      var containers = document.querySelectorAll('.product-recommendations [data-slider-options], .related-products [data-slider-options], recommendation-slider [data-slider-options]');
      containers.forEach(function(c){
        var raw = c.getAttribute('data-slider-options');
        if (!raw) return;
        try {
          var opts = JSON.parse(raw.replace(/'/g, '"'));
          opts.auto_play = 1; // 1 saniye
          c.setAttribute('data-slider-options', JSON.stringify(opts));
        } catch(e){}
      });
      // Swiper instance'ı varsa delay+speed güncelle
      setTimeout(function(){
        document.querySelectorAll('.product-recommendations .swiper, .related-products .swiper, [class*="product-recommendations"] .swiper').forEach(function(s){
          if (s && s.swiper) {
            if (s.swiper.params.autoplay) {
              s.swiper.params.autoplay = Object.assign({}, s.swiper.params.autoplay, {
                delay: AUTO_DELAY,
                disableOnInteraction: false
              });
            } else {
              s.swiper.params.autoplay = { delay: AUTO_DELAY, disableOnInteraction: false };
            }
            s.swiper.params.speed = TRANS_SPEED;
            s.swiper.params.slidesPerGroup = 1;
            try {
              if (s.swiper.autoplay && s.swiper.autoplay.stop) { s.swiper.autoplay.stop(); s.swiper.autoplay.start(); }
            } catch(e){}
          }
        });
        // Slick slider varsa (some sections use slick) — slickSetOption
        if (window.jQuery) {
          jQuery('.product-recommendations [data-slick], .related-products [data-slick], [class*="product-recommendations"] .slick-initialized').each(function(){
            try {
              jQuery(this).slick('slickSetOption', 'autoplaySpeed', AUTO_DELAY, false);
              jQuery(this).slick('slickSetOption', 'speed', TRANS_SPEED, false);
              jQuery(this).slick('slickSetOption', 'slidesToScroll', 1, true);
            } catch(e){}
          });
        }
      }, 1500);
    } catch(e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tuneRelatedSliders);
  } else {
    tuneRelatedSliders();
  }

  /* ──────────────────────────────────────────────────────────
   * SWATCH HOVER IMAGE SWAP
   * Koleksiyon / slider kartlarında renge üzerine gelindiğinde,
   * tıklamadan o rengin ürün görseli karta yüklenir.
   * - data-swatch-img="..." → hover'da <img> src/srcset'e yazılır
   * - mouseleave → orijinal src geri döner
   * - Pointer (touch) için tap-to-preview: touchstart ile geçici swap
   * - Sadece gerçekten farklı URL varsa swap yapılır (görsel flicker yok)
   * ────────────────────────────────────────────────────────── */
  function initSwatchHoverImage() {
    try {
      var selector = [
        '.limsa-slider-card',
        '.limsa-featured__card',
        '.card-wrapper',
        '[data-limsa-card]'
      ].join(',');

      function findCardImg(root) {
        if (!root) return null;
        // Öncelik: limsa slider img, sonra standart card__media img, sonra ilk img
        return root.querySelector(
          '.limsa-slider-card__img, img.card__media-img, .card__media img, .media img, img'
        );
      }

      /* Preload cache — aynı URL'yi 2. hover'da anında yükle (zero flash) */
      var preloadCache = {};
      function preload(url) {
        if (!url || preloadCache[url]) return;
        var img = new Image();
        img.src = url;
        preloadCache[url] = img;
      }

      function applyImg(img, url) {
        if (!img || !url) return;
        if (url.indexOf('//') === 0) url = 'https:' + url;
        if (img.src === url || img.currentSrc === url) return;
        // Saklanmamışsa originali sakla
        if (!img.getAttribute('data-original-src')) {
          img.setAttribute('data-original-src', img.currentSrc || img.src || '');
          var srcset = img.getAttribute('srcset');
          if (srcset) img.setAttribute('data-original-srcset', srcset);
        }
        // Mini fade (80ms CSS transition zaten)
        img.classList.add('limsa-swap-fade');
        img.removeAttribute('srcset');
        img.src = url;
        var clear = function(){ img.classList.remove('limsa-swap-fade'); };
        img.onload = clear;
        setTimeout(clear, 200); // safety — cached zaten anında
      }

      function restoreImg(img) {
        if (!img) return;
        var orig = img.getAttribute('data-original-src');
        var origSet = img.getAttribute('data-original-srcset');
        if (orig && img.src !== orig) {
          img.classList.add('limsa-swap-fade');
          img.src = orig;
          if (origSet) img.setAttribute('srcset', origSet);
          var clear = function(){ img.classList.remove('limsa-swap-fade'); };
          img.onload = clear;
          setTimeout(clear, 200);
        }
      }

      function bind(dot) {
        if (dot.dataset.limsaSwapBound) return;
        var url = dot.getAttribute('data-swatch-img');
        if (!url) return;
        dot.dataset.limsaSwapBound = '1';

        var card = dot.closest(selector);
        if (!card) return;
        var img = findCardImg(card);
        if (!img) return;

        // Card viewport'a girince tüm swatch URL'lerini preload et
        try {
          var absUrl = url.indexOf('//') === 0 ? 'https:' + url : url;
          preload(absUrl);
        } catch(e){}

        // Hover'dan daha hızlı reaksiyon: pointerover (mouse+pen+touch)
        dot.addEventListener('pointerover', function(){ applyImg(img, url); });
        dot.addEventListener('mouseleave', function(){ restoreImg(img); });
        dot.addEventListener('pointerleave', function(){ restoreImg(img); });
        // Touch: tap preview
        dot.addEventListener('touchstart', function(){
          applyImg(img, url);
          clearTimeout(dot._limsaRestoreT);
          dot._limsaRestoreT = setTimeout(function(){ restoreImg(img); }, 2500);
        }, { passive: true });
      }

      function scanAll() {
        document.querySelectorAll('.limsa-swatches__dot[data-swatch-img]').forEach(bind);
      }
      scanAll();

      // Dinamik yüklenenler (collection infinite scroll / AJAX) için observer
      if (window.MutationObserver) {
        var mo = new MutationObserver(function(mutations){
          for (var i=0; i<mutations.length; i++) {
            var added = mutations[i].addedNodes;
            for (var j=0; j<added.length; j++) {
              var n = added[j];
              if (n && n.nodeType === 1 && (n.matches && n.matches('.limsa-swatches__dot[data-swatch-img]') || n.querySelector && n.querySelector('.limsa-swatches__dot[data-swatch-img]'))) {
                scanAll();
                break;
              }
            }
          }
        });
        mo.observe(document.body, { childList: true, subtree: true });
      }
    } catch(e){}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwatchHoverImage);
  } else {
    initSwatchHoverImage();
  }

  /* ─────────────────────────────────────────────────────────
   * PRODUCT RECOMMENDATIONS — erken fetch (mobile fix)
   * <product-recommendations> custom element IntersectionObserver ile
   * lazy fetch yapıyor. Mobilde scroll hızlı + rootMargin küçük ise
   * preview hiç gelmiyor. Çözüm: sayfa yüklendiğinde 600ms sonra boş
   * kalan her <product-recommendations>'u manuel fetch + inject.
   * ───────────────────────────────────────────────────────── */
  function forceLoadRecommendations() {
    try {
      var nodes = document.querySelectorAll('product-recommendations[data-url]');
      nodes.forEach(function(el) {
        if (el.dataset.limsaLoaded) return;
        var innerLen = (el.innerHTML || '').trim().length;
        if (innerLen > 800 && el.querySelector('.grid__item, .swiper-slide, .card-wrapper')) {
          el.dataset.limsaLoaded = '1';
          return;
        }
        var url = el.getAttribute('data-url');
        if (!url) return;
        el.dataset.limsaLoaded = '1';

        fetch(url, { credentials: 'same-origin' })
          .then(function(r){ return r.text(); })
          .then(function(text) {
            var div = document.createElement('div');
            div.innerHTML = text;
            var src = div.querySelector('product-recommendations');
            if (src && src.innerHTML.trim().length > 100) {
              el.innerHTML = src.innerHTML;
              el.classList.add('product-recommendations--loaded');

              /* ─── INJECT SONRASI POST-PROCESS ───
               * 1) Swiper'ın lazy-image yaklaşımı (data-src → src) mobilde
               *    Swiper init olmazsa tetiklenmez. Her img için src/srcset
               *    doğrulama + loading=eager + decoding=async
               * 2) Swiper instance'ı manuel restart dene (init olduysa)
               * 3) Olmadıysa .swiper-wrapper'ı native scroll grid yap — CSS
               *    fallback zaten hazır, ek bir class verelim */
              setTimeout(function(){
                try {
                  // 1. Img normalize
                  el.querySelectorAll('img').forEach(function(img){
                    // data-src varsa src'e kopyala
                    var ds = img.getAttribute('data-src');
                    if (ds && (!img.getAttribute('src') || img.getAttribute('src').indexOf('data:') === 0)) {
                      img.setAttribute('src', ds);
                    }
                    var dsSet = img.getAttribute('data-srcset');
                    if (dsSet && !img.getAttribute('srcset')) {
                      img.setAttribute('srcset', dsSet);
                    }
                    img.setAttribute('loading', 'eager');
                    img.setAttribute('decoding', 'async');
                    // Lazyloaded class Swiper tema default — kaldır
                    img.classList.remove('swiper-lazy');
                    img.classList.remove('lazy');
                    img.classList.remove('lazyload');
                    img.classList.add('swiper-lazy-loaded');
                  });

                  // 2. Swiper instance manuel init (Safe)
                  var slider = el.querySelector('recommendation-slider');
                  if (slider && !slider._limsaInit) {
                    slider._limsaInit = 1;
                    // Eğer Swiper class varsa manuel Swiper başlat
                    try {
                      if (window.Swiper && typeof window.Swiper === 'function') {
                        var swEl = slider.querySelector('[data-swiper-slider]') || slider.querySelector('.swiper');
                        if (swEl && !swEl._limsaSwiperInited) {
                          swEl._limsaSwiperInited = 1;
                          var opts = {
                            slidesPerView: (window.innerWidth < 750) ? 1.2 : 4,
                            spaceBetween: (window.innerWidth < 750) ? 10 : 20,
                            loop: false,
                            autoplay: { delay: (window.innerWidth < 768) ? 2000 : 1500, disableOnInteraction: false },
                            speed: 700,
                            breakpoints: {
                              320: { slidesPerView: 1.3, spaceBetween: 10 },
                              576: { slidesPerView: 2.2, spaceBetween: 12 },
                              750: { slidesPerView: 3, spaceBetween: 16 },
                              990: { slidesPerView: 4, spaceBetween: 20 }
                            }
                          };
                          new window.Swiper(swEl, opts);
                        }
                      }
                    } catch(e){}
                  }

                  // 3. CSS native fallback flag
                  el.classList.add('limsa-recs-ready');
                  if (slider) slider.classList.add('limsa-recs-ready');

                  // Swatch hover image-swap'ı yeniden bind
                  if (typeof initSwatchHoverImage === 'function') initSwatchHoverImage();
                  if (typeof tuneRelatedSliders === 'function') tuneRelatedSliders();
                } catch(e){}
              }, 250);
            }
          })
          .catch(function(e){ /* sessiz fail */ });
      });
    } catch(e){}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      setTimeout(forceLoadRecommendations, 600);
      setTimeout(forceLoadRecommendations, 2500);
    });
  } else {
    setTimeout(forceLoadRecommendations, 600);
    setTimeout(forceLoadRecommendations, 2500);
  }
})();
